var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.455,
    height: 22.016,
    viewBox: "0 0 23.455 22.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -15.033)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.148,132.857a6.424,6.424,0,1,0-6.424,6.424A6.437,6.437,0,0,0,123.148,132.857Zm-6.424,4.432a4.48,4.48,0,1,1,4.48-4.48A4.462,4.462,0,0,1,116.724,137.289Z",
    transform: "translate(-105.02 -121.101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.357,18.274a9.769,9.769,0,0,1,9.712,0,.983.983,0,0,0,1-1.694,12.006,12.006,0,0,0-5.825-1.546,11.554,11.554,0,0,0-5.878,1.594,1.034,1.034,0,0,0-.349,1.345A.912.912,0,0,0,113.357,18.274Z",
    transform: "translate(-106.535 -15.033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.874,249.244a9.714,9.714,0,0,1-4.882-8.415,1,1,0,0,0-1-1,1,1,0,0,0-1,1,11.714,11.714,0,0,0,5.878,10.11.983.983,0,1,0,1-1.694Z",
    transform: "translate(0 -229.072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.939,237.733a1,1,0,0,0-1,1,9.854,9.854,0,0,1-4.882,8.468,1.034,1.034,0,0,0-.349,1.345.938.938,0,0,0,1.393.3,11.641,11.641,0,0,0,5.83-10.11v-.048A.958.958,0,0,0,342.939,237.733Z",
    transform: "translate(-320.48 -227.073)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.bc0107bf3b9962a99a20bb7810b4a307.svg";
export { ForwardRef as ReactComponent };